
import Vue from "vue";
import { UserInfo } from "../../models/dossier/user-info";
import { DossierService } from "../../services/dossier-service";
import { ViewService } from "../../services/view-service";
import { View } from "@/models/view";
import AppUsersSelectViews from "./UsersSelectViews.vue";

export default Vue.extend({
	data(){
		return {
			selectedUser: null as null | UserInfo,
			users: [] as UserInfo[],
			selectedViews: [] as View[],
			overwriteExistingViews: false
		};
	},
	props: {
		value: Boolean,
		userId: Number
	},
	computed: {
		selectedUserId():number {
			if (!this.selectedUser) {
				return 0;
			}
			return this.selectedUser.ID;
		}
	},
	methods: {
		async selectUser(user:UserInfo){
			this.selectedViews = [];
			this.selectedUser = user;
		},

		cancel(){
			this.selectedUser = null;
			this.selectedViews = [];
			this.$emit("input", false);
		},
		onInput(value:boolean){
			this.selectedUser = null;
			this.selectedViews = [];
			this.$emit("input", false);
		},
		async doOverwriteExistingViews(userId:number){
			if (!this.overwriteExistingViews) return;
			let views = await ViewService.getUsersViews(userId);
			let result:View[] = [];
			for (let view of this.selectedViews){
				let foundViews = views.filter(v=>v.BrowseID == view.BrowseID && v.Name.toLowerCase() == view.Name.toLocaleLowerCase());
				if (foundViews.length == 0)continue;
				result.push(...foundViews);
			}
			if (result.length > 0){
				await ViewService.deleteViews(result);
			}
		},
		async importViews(){
			await this.doOverwriteExistingViews(this.userId);
			for (let v of this.selectedViews){
				v.UserID = this.userId;
			}
			await ViewService.createViews(this.selectedViews);
			this.cancel();
		}
	},
	async created(){
		let users = await DossierService.getUsers();
		this.users = users.filter(u=>u.ID != this.userId);
	},
	components: {
		AppUsersSelectViews
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
